import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';

export class EventSubscribers {
  public static onDocumentclick = Observable.fromEvent(document, 'click');
  public static onDocumentClickCapture = Observable.fromEvent(document, 'click', { capture: true });
  public static onWindowBeforeUnload = Observable.fromEvent(window, 'beforeunload');
}



// WEBPACK FOOTER //
// ./src/app/shared/eventSubscribers.ts